<template>
  <div class="content">
    <div class="login-title">
      账号登录
    </div>
    <div class="verify-code">
      <div class="verify-button" @click="VCodeLogin">
        短信验证码登陆
      </div>
    </div>
    <div class="phone-box">
      <div class="eight-six">
        +86
      </div>
      <img src="../assets/mq_arrow_down_icon.png" class="arrow-icon">
      <input onkeyup="this.value=this.value.replace(/\D/g,'')" onafterpaste="this.value=this.value.replace(/\D/g,'')" placeholder="请输入手机号" class="input-style" v-model="phone"/>
    </div>
    <div class="phone-box">
      <input onkeyup="value=value.replace(/[^\w\.\/]/ig,'')" type="password" class="input-style" placeholder="请输入密码" style="margin-left: 18px" v-model="password">
    </div>
    <div class="verify-code" style="margin-top: 24px;">
      <input type="checkbox">
      <div class="auto-login" @click="changeVCode">
        两周内自动登录
      </div>
    </div>
    <div class="login-button" @click="login()">
      登录
    </div>
    <div class="register-button" @click="changeToRegister()">
      注册
    </div>
    <div class="forget-password" @click="forgetPassword()">
      忘记密码
    </div>
  </div>
</template>

<script>
import {postAction} from '../network/GetAndPost'
import Vue from 'vue'
export default {
  name: 'AccountLogin',
  methods: {
    changeToRegister () {
      this.$emit('RLChange')
    },
    changeVCode () {
    },
    login () {
      postAction(this.passwordLoginUrl,{"phone": this.area+this.phone, "password": this.password}).then((res)=>{
        if(res.status === 200){
          Vue.ls.set("Access-Token",res.result.token,60 * 60 * 1000 * 24 * 14)
          Vue.ls.set("userInfo",res.result,60 * 60 * 1000 * 24 * 14)
          this.$router.push({name:'personalMain'})
        }else {
          alert("密码错误，请重新输入密码");
        }

      })
    },
    forgetPassword () {
      this.$emit('PLChange')
    },
    VCodeLogin () {
      this.$emit('VLChange')
    }
  },
  data () {
    return {
      passwordLoginUrl: '/index/index/passwordLogin',
      phone: '',
      area: '+86',
      password: ''
    }
  }
}
</script>

<style scoped>
.content{
  width: 647px;
  height: 700px;
  background-color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.forget-password{
  margin-top: 48px;
  font-size: 18px;
  font-weight: 400;
  color: #009CEE;
  line-height: 25px;
  cursor: pointer;
}
.register-button{
  margin-top: 20px;
  width: 457px;
  height: 60px;
  border: 1px solid #009CEE;
  font-size: 22px;
  font-weight: 500;
  color: #009CEE;
  line-height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.login-button{
  margin-top: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 30px;
  width: 460px;
  height: 60px;
  background: #009CEE;
  cursor: pointer;
}
.auto-login{
  font-size: 18px;
  font-weight: 400;
  color: #666666;
  line-height: 25px;
  margin-left: 10px;
}
.input-style{
  background:none;
  outline:none;
  border:none;
  font-size: 20px;
  font-weight: 500;
  color: #000000;
  line-height: 28px;
  margin-left: 14px;
}
.arrow-icon{
  margin-left: 15px;
  width: 21px;
  height: 13px;
}
.eight-six{
  font-size: 20px;
  font-weight: 600;
  color: #000000;
  line-height: 28px;
  margin-left: 18px;
}
.phone-box{
  margin-top: 20px;
  width: 459px;
  height: 60px;
  background: #FFFFFF;
  border: 1px solid #E8E8E8;
  display: flex;
  align-items: center;
}
.verify-button{
  cursor: pointer;
  font-size: 18px;
  font-weight: 400;
  color: #009CEE;
  line-height: 25px;
}
.verify-code{
  margin-top: 46px;
  width: 460px;
  display: flex;
  flex-direction: row;
  justify-content: end;
  align-items: center;
}
.login-title{
  margin-top: 67px;
  font-size: 28px;
  font-weight: 600;
  color: #000000;
  line-height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/AccountLogin.vue